import { useSettlementBlackoutDates } from 'components/common-form/hooks/use-settlement-blackout-dates';
import { DatePickerLabelled } from 'components/shared/DatePicker/date-picker-labelled';
import { useTranslateForm } from 'hooks/use-translate-payoff';
import { DateFieldMetadata } from 'models/forms/fields';
import { ErrorWrapper } from 'routes/essential-workspace/components/form/error-wrapper';
import { useFormErrors } from 'routes/essential-workspace/components/form/use-form-errors';
import { useFormFieldData } from 'routes/essential-workspace/components/form/use-form-field-data';
import { getDateOnlyFromIsoString } from 'utils/date';

export function DateField({ translationKey, id, isReadOnly, allowWeekend, calendars }: DateFieldMetadata) {
  const [value, setFormData] = useFormFieldData<Nullable<string>>(id);
  const formattedValue = getDateOnlyFromIsoString(value);

  const { getFieldError } = useFormErrors();
  const fieldError = getFieldError(id);

  const { translateLabel } = useTranslateForm();
  const label = translateLabel(translationKey ?? id);

  const blackoutDates = useSettlementBlackoutDates(calendars);

  return (
    <ErrorWrapper error={fieldError}>
      <DatePickerLabelled
        allowWeekend={allowWeekend}
        id={id}
        label={label}
        onChange={setFormData}
        values={[formattedValue]}
        isReadOnly={isReadOnly}
        isInvalid={fieldError?.severity === 'Error'}
        isHighlighted={fieldError?.severity === 'Warning'}
        blackoutDates={blackoutDates}
      />
    </ErrorWrapper>
  );
}
